import { struct } from 'io-ts/Decoder';

import { Id as MaterialTempalteUsageId } from '../../../../../whole-house/material-template/usage/Id';

export const Param = struct({
	materialTemplateUsageId: MaterialTempalteUsageId,
});
